module.exports = __webpack_public_path__ + "static/img/kwh_good2.b24df93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/kwh_good2.png
// module id = rujF
// module chunks = 1